import { useState, useCallback, useEffect } from "react";
import { getImagePaths } from "utils/getImagePaths";

export const useFetchImagePaths = ({ path }: { path: string }) => {
  const [imagePaths, setImagePaths] = useState<string[]>([]);
  const fetchImagePaths = useCallback(async () => {
    const paths = await getImagePaths({
      basePath: path,
      pathExtension: ".jpg",
    });
    setImagePaths(paths);
  }, [path]);

  useEffect(() => {
    fetchImagePaths();
  }, [fetchImagePaths, path]);
  return { imagePaths };
};
